module.exports = __webpack_public_path__ + "static/img/cp_icon_B01.67d6c51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/cp_icon_B01.png
// module id = W7hF
// module chunks = 1